import React from "react";
import { Stack, StackProps, Button, Typography, styled } from "@mui/material";
import EditOutllinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import InsertPhotoOutlinedIcon from "@mui/icons-material/InsertPhotoOutlined";
import MovieOutlinedIcon from "@mui/icons-material/MovieOutlined";
import SubtitlesOutlinedIcon from "@mui/icons-material/SubtitlesOutlined";
import SmartDisplayOutlinedIcon from "@mui/icons-material/SmartDisplayOutlined";
import SourceOutlinedIcon from "@mui/icons-material/SourceOutlined";
import { TranskodeBundleComponent } from "../../../../Core/Api/Types/transkode-bundle-component";
import { TranskodeBundleComponentType } from "../../../../Core/Api/Types/transkode-bundle-component-type";
import { useTranslation } from "react-i18next";
interface ConfigPackageBundleComponentProps extends StackProps {
  _component: TranskodeBundleComponent;
  missingContent: boolean;
  onEdit: () => void;
  onDelete?: () => void;
}

const ConfigPackageBundleComponent: React.FC<ConfigPackageBundleComponentProps> = (props) => {
  const { t } = useTranslation();
  const { _component: component, missingContent, onEdit, onDelete, ...otherProps } = props;

  const getIcon = (type: TranskodeBundleComponentType) => {
    switch (type) {
      case TranskodeBundleComponentType.Artwork:
        return <InsertPhotoOutlinedIcon htmlColor="#DC66FA" />;
      case TranskodeBundleComponentType.Episode:
      case TranskodeBundleComponentType.Feature:
        return <MovieOutlinedIcon htmlColor="#DC66FA" />;
      case TranskodeBundleComponentType.Teaser:
      case TranskodeBundleComponentType.Trailer:
        return <SmartDisplayOutlinedIcon htmlColor="#DC66FA" />;
      case TranskodeBundleComponentType.DubCard:
        return <SubtitlesOutlinedIcon htmlColor="#DC66FA" />;
      default:
        return <SourceOutlinedIcon htmlColor="#DC66FA" />;
    }
  };

  return (
    <Card direction="row" alignItems="center" justifyContent="space-between" spacing={2} {...otherProps}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <figure>{getIcon(component.type!)}</figure>
        <Stack>
          <Typography color="text.primary">{component.type}</Typography>
          <Typography color="text.secondary" variant="body2">
            {t("component:body.includedAssets", { count: component.assets ? component.assets.length : 0 })}
          </Typography>
        </Stack>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1}>
        {missingContent && (
          <Typography color="warning.main" variant="body2" fontWeight={500} mr={1}>
            {t("component:body.informationMissing")}
          </Typography>
        )}
        <Button variant="icon" onClick={onEdit} size="small">
          <EditOutllinedIcon />
        </Button>
        <Button
          variant="icon"
          onClick={onDelete}
          size="small"
          disabled={component.minItems !== null && component.minItems! > 0}
        >
          <DeleteOutlinedIcon color="error" />
        </Button>
      </Stack>
    </Card>
  );
};

export default ConfigPackageBundleComponent;

const Card = styled(Stack)(({ theme }) => ({
  borderRadius: 8,
  padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
  border: `1px solid ${theme.palette.backgroundAlpha.border}`,

  figure: {
    background: "rgba(220, 102, 250, 0.08)",
    borderRadius: 6,
    overflow: "hidden",
    width: 40,
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));
